import { gql } from '../types/generated';

export const GET_ACTIVE_LOCATION_OVERRIDES = gql(`
  query getActiveLocationOverrides {
    getActiveLocationOverrides(page: 0, size: 9999999) {
      currentPage
      totalPages
      overrides {
        oktaId
        zipCode
        ipAddress
        countryCode
        expiration
        createdAt
      }
    }
  }
`);

export const GET_USER_INFO = gql(`
  query userInfo($email: String!) {
    userInfo(email: $email) {
      id
      email
      firstName
      lastName
    }
  }
`);
